import { Component } from '@angular/core';

@Component({
    selector: 'app-master-widget-icon',
    templateUrl: './master-widget-icon.component.html',
    styleUrls: ['./master-widget-icon.component.scss'],
})
export class MasterWidgetIconComponent {}
